import { isDesktop } from '@carboncopyco/mimesis-shared';

export const getScreenshotBase64 = async (
  shouldTakeScreenshots?: boolean,
  uuid?: number
) => {
  if (isDesktop && shouldTakeScreenshots && uuid) {
    try {
      return await window.dsDesktop.tour.takeScreenshot(uuid);
    } catch (e) {
      console.error(e);
      return Promise.resolve(null);
    }
  }

  return Promise.resolve(null);
};
